import { AutogenLayoutSettlementTimecardHistory } from "./autogen/AutogenLayoutSettlementTimecardHistory";
import { DataSourceMode, DataSourceModeChangeEvent } from "@mcleod/components";

export class SettlementTimecardHistory extends AutogenLayoutSettlementTimecardHistory {

    /** This is an event handler for the afterModeChange event of sourceDrsTimecardHist. */
    sourceDrsTimecardHistAfterModeChange(event: DataSourceModeChangeEvent) {
        this.dataheaderTimecardHistory.showExecute = event.newMode === DataSourceMode.SEARCH;
    }
}
